import { ColorOptions } from '@jfs/ui-new'
import Svg, { G } from 'react-native-svg'
import { convertHexToRGBA } from '../../../utils'

export const TopPhone = ({ height, width, color }: { height: any; width: any; color: any }) => {
  return (
    <Svg id="TopPhones" width={width} height={height} viewBox="0 0 64 76">
      <G id="TopPhone" transform="translate(-570 -487)">
        <rect
          id="Backgroud"
          width="64"
          height="63"
          rx="31.5"
          transform="translate(570 494)"
          fill={convertHexToRGBA(color, 10) as ColorOptions}
        />
        <G
          id="Phone"
          transform="translate(580 487)"
          fill="#fff"
          stroke={convertHexToRGBA(color, 20) as ColorOptions}
          stroke-width="2">
          <rect width="44" height="76" rx="4" stroke="none" />
          <rect x="1" y="1" width="42" height="74" rx="3" fill="none" />
        </G>
        <G id="Phone-2" data-name="Phone" transform="translate(585.772 495.356)" opacity="0.2">
          <rect
            id="Rectangle_1076"
            data-name="Rectangle 1076"
            width="9"
            height="9"
            rx="2"
            transform="translate(0.227 -0.356)"
            fill={color}
          />
          <rect
            id="Rectangle_1081"
            data-name="Rectangle 1081"
            width="9"
            height="9"
            rx="2"
            transform="translate(0.227 12.644)"
            fill={color}
          />
          <rect
            id="Rectangle_1084"
            data-name="Rectangle 1084"
            width="9"
            height="9"
            rx="2"
            transform="translate(0.227 25.644)"
            fill={color}
          />
          <rect
            id="Rectangle_1077"
            data-name="Rectangle 1077"
            width="10"
            height="9"
            rx="2"
            transform="translate(11.227 -0.356)"
            fill={color}
          />
          <rect
            id="Rectangle_1080"
            data-name="Rectangle 1080"
            width="10"
            height="9"
            rx="2"
            transform="translate(11.227 12.644)"
            fill={color}
          />
          <rect
            id="Rectangle_1083"
            data-name="Rectangle 1083"
            width="10"
            height="9"
            rx="2"
            transform="translate(11.227 25.644)"
            fill={color}
          />
          <rect
            id="Rectangle_1078"
            data-name="Rectangle 1078"
            width="9"
            height="9"
            rx="2"
            transform="translate(23.227 -0.356)"
            fill={color}
          />
          <rect
            id="Rectangle_1079"
            data-name="Rectangle 1079"
            width="9"
            height="9"
            rx="2"
            transform="translate(23.227 12.644)"
            fill={color}
          />
          <rect
            id="Rectangle_1082"
            data-name="Rectangle 1082"
            width="9"
            height="9"
            rx="2"
            transform="translate(23.227 25.644)"
            fill={color}
          />
        </G>
        <circle
          id="Phone-3"
          data-name="Phone"
          cx="3"
          cy="3"
          r="3"
          transform="translate(599 551)"
          fill={color}
          opacity="0.2"
        />
      </G>
    </Svg>
  )
}
